import React from 'react'

const SvgAbdominalMeasuresFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.97 11.555a.9.9 0 01-.652 1.097c-.307.079-.609.154-.906.226a.91.91 0 01-1.1-.659.9.9 0 01.666-1.089c.29-.07.584-.144.885-.22a.91.91 0 011.108.645zm-19.942.004a.91.91 0 011.105-.65c.301.075.597.147.886.216a.9.9 0 01.671 1.086.91.91 0 01-1.097.664c-.297-.07-.6-.145-.908-.222a.9.9 0 01-.657-1.094zm3.587.853a.908.908 0 011.06-.72c.614.114 1.204.21 1.775.286.498.068.846.521.778 1.014a.908.908 0 01-1.023.77 38.844 38.844 0 01-1.863-.3.9.9 0 01-.727-1.05zm12.774.012a.9.9 0 01-.723 1.052 36.2 36.2 0 01-1.868.302.907.907 0 01-1.023-.77.902.902 0 01.78-1.013 34.19 34.19 0 001.772-.287.909.909 0 011.062.716zm-8.217.655a.906.906 0 01.944-.864c.599.023 1.188.025 1.777.006a.905.905 0 01.939.87.904.904 0 01-.879.929c-.633.02-1.266.019-1.909-.006a.904.904 0 01-.872-.935z'
    />
    <path d='M4.727 10.65c.771-2.475.002-6.313 0-7.65h14.546c-.03 1.391-.497 5.127 0 7.65-1.819.75-7.273 1.8-14.546 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.273 13.8L2.909 21h18.182l-1.364-7.2c-5.738 1.544-9.11 1.608-15.454 0zM12 17.4c.502 0 .91-.403.91-.9s-.408-.9-.91-.9a.905.905 0 00-.91.9c0 .497.408.9.91.9z'
    />
  </svg>
)

export default SvgAbdominalMeasuresFilled
